<template>
    <hts-drawer
        v-model="visible"
        color="main"
        :title="$t('labels.driverModule.license.add')"
        :submit="visibleCreateLicense"
        :rules="rulesLicense"
        @close="closeOverSide">
        <hts-card :title="$t('labels.generalInformation')">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-input
                    v-model="dataLicense.licenseNumber"
                    :required="true"
                    :label="$t('labels.driverModule.license.no')"
                    name="driverModule.license.no"
                    prop="driverModule.license.no" />
                <hts-form-select
                    v-model="dataLicense.licenseClass"
                    :label="$t('labels.driverModule.license.class')"
                    required
                    :items="license() || []"
                    key-id="key"
                    key-label="key"
                    key-tooltip="keyDes"
                    :color="color"
                    :multiple="true"
                    name="driverModule.license.class"
                    prop="driverModule.license.class" />
                <hts-form-date
                    v-model="dataLicense.expiredDate"
                    :required="true"
                    :label="$t('labels.driverModule.license.expires')"
                    :color="color"
                    name="driverModule.license.expires"
                    prop="driverModule.license.expires" />
            </div>
        </hts-card>

        <hts-card :title="$t('labels.driverModule.license.image')">
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-file
                    v-model="dataLicense.licenseFront"
                    type="file"
                    :label="$t('labels.driverModule.license.front')"
                    :color="color"
                    required
                    readonly
                    name="driverModule.license.front"
                    prop="driverModule.license.front" />
                <hts-form-file
                    v-model="dataLicense.licenseBack"
                    type="file"
                    :label="$t('labels.driverModule.license.back')"
                    :color="color"
                    required
                    readonly
                    name="driverModule.license.back"
                    prop="driverModule.license.back" />
            </div>
            <hts-modal
                :show="openPopupConfirmLicense"
                :title="$t('labels.confirmCreateLicense')"
                type="confirm"
                :content="$t('labels.contentConfirmExpiredDateLicense')"
                @hide="openPopupConfirmLicense = false"
                @confirm="submitFom" />
        </hts-card>
    </hts-drawer>
</template>

<script lang="ts" setup>
import form from './imports/form'
import data from './imports/data'
const { license } = data()

const props = defineProps({
  show: {
    type: Boolean,
    default: true,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 2
  }
})

const { show } = toRefs(props)

const codeDriver = ref('')
const visible = ref(false)

const _initForm = {
  licenseNumber: '',
  licenseClass: null,
  expiredDate: '',
  licenseFront: '',
  licenseBack: ''
} as { [key: string]: any }

const dataLicense = reactive({ ..._initForm })
const rulesLicense = ref(form.rulesLicense)
const emits = defineEmits(['close', 'refreshTables', 'update:show'])

const open = (idDriver: string) => {
  visible.value = true
  codeDriver.value = idDriver
}
defineExpose({
  open
})

const openPopupConfirmLicense = ref(false)

const visibleCreateLicense = async () => {
  if (new Date(dataLicense.expiredDate + ' 23:59:59').getTime() < new Date().getTime()) {
    openPopupConfirmLicense.value = true
  } else {
    await submitFom()
  }
}

const submitFom = async () => {
  const dataForm = new FormData()
  dataForm.append('driver', codeDriver.value || '')
  dataForm.append('licenseNumber', dataLicense.licenseNumber)
  dataForm.append('licenseClass', JSON.stringify(dataLicense.licenseClass))
  dataForm.append('expiredDate', dataLicense.expiredDate)
  dataForm.append('files', dataLicense.licenseFront) // ảnh trước CMND là phần tử thứ nhất
  dataForm.append('files', dataLicense.licenseBack) // ảnh sau CMND là phần tử thứ 2

  const api = $url.driver.license.add

  const data: any = await $api(api, { body: dataForm })

  const resData: any = data?.data?.value
  if (resData?.success) {
    process.client && $toast().success($t('labels.addSuccess'))
    emits('refreshTables')
    undo()
    visible.value = false
    openPopupConfirmLicense.value = false
  }
}

const closeOverSide = () => {
  emits('close')
}

const undo = () => {
  Object.assign(dataLicense, { ..._initForm })
}
</script>
